import { loader } from 'graphql.macro'

export default function dispatchTicket ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./dispatchTicket.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    ticketId: variables.ticketId
  })
}
